import React from 'react'
import './resetPwd.css'
import {showErrorMsg} from "../utils/commonFunc";
import { Button, message } from 'antd';
import MD5 from 'md5'
import {fetchGet, fetchPost} from "../utils/fetchData";
import {convert_FormData_to_json2} from "../../config";

class Reset_Pwd extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            serialNo : '',//流水号
        }
    }

    clearInputBox = () => {
        this.refs.mobileNo.value = null;
        this.refs.mobileCode.value = null;
        this.refs.newPwd.value = null;
        this.refs.newPwdConfirm.value = null;
    };

    submitRequest = () => {
        let mobile = this.refs.mobileNo.value;
        let mobileCode = this.refs.mobileCode.value;
        let newPwd = this.refs.newPwd.value;
        let newPwdConfirm = this.refs.newPwdConfirm.value;

        if (mobileCode.length == 0) {
            message.error('请输入短信验证码');
        }
        else if (newPwd.length == 0) {
            message.error('请输入新密码');
        }
        else if (newPwdConfirm.length == 0) {
            message.error('请确认新密码');
        }

        else if (newPwd === newPwdConfirm) {
                this.clearInputBox();

                let formData = new FormData();

                formData.append("mobile", mobile);
                formData.append("new_pwd", MD5(newPwd));
                formData.append("code", mobileCode);
                formData.append("seria_no", this.state.serialNo);
                let retData = fetchPost('password',convert_FormData_to_json2(formData),null)
                retData.then(data => {
                    if (data.code === 200) {
                        message.success('密码修改成功');
                    }
                    else {
                        showErrorMsg(data);
                    }
                })

        } else {
            message.error('新密码不一致');
        }



    };

    getMobileCode = () => {
        let that = this;

        let mobile = this.refs.mobileNo.value;
        if (mobile.length == 0) {
            message.error('请输入手机号码');
        }
        else{
          let formData = new FormData();
          formData.append("mobile", this.refs.mobileNo.value);
          formData.append("type", 3);

          let retValue = fetchPost('mobile',convert_FormData_to_json2(formData),null);
              retValue.then(data => {
                  console.log(data);
                  if (data.code === 200) {
                      message.success('获取验证码成功');
                      that.setState({
                          serialNo:data.data.seria_no,
                      })



                  }
                  else {
                      message.error(data);
                  }
              })
        }


    };

    render(){
        let display = this.props.pwdVisible?'block':'none';
        return(
            <div style={{display:display}} className='div_reset_pwd_style'>
                <div className='div_reset_content'>
                    <p style={{marginLeft:0 + 'px'}}>输入手机号码</p>

                    <input ref='mobileNo' className='input_pwd_style'/>
                    <Button  type="primary"


                                 onClick={this.getMobileCode}
                                 >获取验证码</Button>
                    <br/>
                    <p style={{marginLeft:0 + 'px'}}>输入短信验证码</p>

                    <input ref='mobileCode' className='input_pwd_style'/>
                    <br/>

                    <p style={{marginLeft:0 + 'px'}}>输入您的新密码</p>
                    <input ref='newPwd' className='input_pwd_style'/>
                    <br/>
                    <p style={{marginLeft:0 + 'px'}}>确认您的新密码</p>
                    <input ref='newPwdConfirm' className='input_pwd_style'/>
                    <br/>
                    <br/>
                    <button onClick={this.submitRequest} className='btn_submit_style'>确认修改</button>
                </div>
            </div>
        );
    }
}

export default Reset_Pwd
